jQuery(document).ready(function ($) {
  function toggleShippingSection(selector, dataTitle, methodSelector) {
    var svg = $(selector)

    // Ensure the section is open on page load.
    $(`[data-title="${dataTitle}"]`).show()
    $(methodSelector).show() // Show the method selector, too.

    // Set the initial state of the SVG transform to indicate it's open.
    svg.addClass('flipped')

    // Toggle visibility on click.
    $(selector).on('click', function () {
      $(`[data-title="${dataTitle}"]`).slideToggle(400, function () {
        var transform = $(methodSelector).is(':visible') ? 'scaleY(-1)' : 'scaleY(1)'
        svg.css('transform', transform)
      })
    })
  }

  function toggleEverything() {
    toggleShippingSection(
      '.bgf_shipping-tab.initial-shipment svg',
      'Initial Shipment',
      'woocommerce-shipping-methods.initial-shipment'
    )

    if ($('.shipping_method_recurring').length === 0) {
      toggleShippingSection(
        '.bgf_shipping-tab.shipping svg',
        'Shipping',
        '.woocommerce-shipping-methods.shipping'
      )
    } else {
      toggleShippingSection(
        '.bgf_shipping-tab-recurring svg',
        'Shipping',
        '.shipping_method_recurring'
      )
    }
  }

  // Initialize toggles
  toggleEverything()

  // Insert a custom divider before the PPC button wrapper if on the cart page
  if (window.location.pathname === '/cart/') {
    $('<div class="em-dash-or">&mdash; OR &mdash;</div>').insertBefore(
      '.ppc-button-wrapper'
    )
  }

  // Reformat product titles
  $('.woocommerce-cart-form__cart-item.cart_item .bgf_product-title>span').each(
    function () {
      var items = $(this).text().split(', ')
      var newContent = items[0]
      for (var i = 1; i < items.length; i++) {
        newContent += '<br>&nbsp;- ' + items[i]
      }
      $(this).html(newContent)
    }
  )

  // Handle WooCommerce fragment refresh
  $(document.body).on('wc_fragments_refreshed', function () {
    toggleEverything()
  })

  // Handle WooCommerce updated shipping method
  $(document.body).on('updated_shipping_method', function () {
    toggleEverything()
  })
})